<ng-container *ngIf="canSwitchOrg$ | async; else readOnlyOrg">
  <div class="org-switcher-wrapper">
    <!-- Trigger for custom dropdown -->
    <div class="custom-select-trigger"
         (click)="toggleDropdown()"
         [class.disabled]="isLoading">
      <span class="current-org-name" [matTooltip]='"ID: " + (currentOrgId$ | async)  + "&nbsp;&nbsp;&nbsp;&nbsp; Legacy ID: " + (organizationLegacyName$ | async)'>{{ currentOrgName$ | async }}</span>
      <mat-icon class="dropdown-arrow" [class.open]="isDropdownOpen">arrow_drop_down</mat-icon>
    </div>

    <!-- Custom dropdown panel -->
    <div class="custom-dropdown-panel" *ngIf="isDropdownOpen" (clickOutside)="closeDropdown()">
      <!-- Header with search and toggle -->
      <div class="dropdown-header">
        <mat-form-field class="search-field" appearance="outline">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput
                 #searchInput
                 placeholder="Search by name, ID, or legacy ID..."
                 [formControl]="orgSearchControl">
        </mat-form-field>

        <mat-slide-toggle
          *ngIf="isSuperUser$ | async"
          [formControl]="showDisabledControl"
          class="show-disabled-toggle">
          Show Disabled
        </mat-slide-toggle>
      </div>

      <!-- Organizations table -->
      <div class="orgs-table-container">
        <table class="orgs-table">
          <thead>
            <tr>
              <th>Organization Name</th>
              <th *ngIf="isSuperUser$ | async" class="action-column">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let org of filteredOrgs$ | async"
                [class.disabled-org]="org.statusID === 1001">
              <td class="org-name-cell" (click)="onOrgSelect(org)" title="{{org.name}}">
                {{ org.name }}
                <span *ngIf="org.statusID === 1001" class="disabled-badge">Disabled</span>
              </td>
              <td *ngIf="isSuperUser$ | async" class="action-cell">
                <button mat-button
                        class="action-btn"
                        [class.enable-btn]="org.statusID === 1001"
                        [class.disable-btn]="org.statusID === 1000"
                        (click)="toggleOrgStatus(org, $event)">
                  {{ org.statusID === 1001 ? 'Enable' : 'Disable' }}
                </button>
              </td>
            </tr>
            <tr *ngIf="(filteredOrgs$ | async)?.length === 0">
              <td [attr.colspan]="(isSuperUser$ | async) ? 2 : 1" class="no-results">
                No organizations found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #readOnlyOrg>
  <div class="org-display">
    <span class="org-name"
      [matTooltip]="organizationLegacyName$ | async"
      matTooltipPosition="below">
      {{ currentOrgName$ | async }}
    </span>
  </div>
</ng-template>
